import { FC, useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import MobilePanelClientTranslationCommand from "../../../services/command/mobilepanelclienttranslation/MobilePanelClientTranslationsCommand.services";

interface IProps {
  selectedRow?: any;
  open?: boolean;
  onClose?: any;
  refresh?: any;
  selectedCulture?: any;
}
export const SCUIMPClientTranslationsDialog: FC<IProps> = ({
  selectedRow,
  open = false,
  onClose,
  refresh,
  selectedCulture,
}) => {
  const [parameter_value, setParameterValue] = useState(
    selectedRow ? selectedRow?.parameter_value : ""
  );

  const [parameter_key, setParameterKey] = useState(
    selectedRow ? selectedRow?.parameter_key : ""
  );
  useEffect(() => {
    setParameterValue(
      selectedRow?.parameter_value === "-" ? " " : selectedRow?.parameter_value
    );
    setParameterKey(
      selectedRow?.parameter_key === "-" ? " " : selectedRow?.parameter_key
    );
  }, [selectedRow]);

  const handleChangeParameterKey = (event: any) => {
    setParameterKey(event.target.value);
  };
  const handleChangeParameterValue = (event: any) => {
    setParameterValue(event.target.value);
  };
  const countryStore: any = useSelector((state: any) => state?.country);

  const { t } = useTranslation();

  const UpdateMobileClientTranslation = async () => {
    let params = {
      ClientKeyId: selectedRow.id,
      ClientTranslationKey: parameter_key,
      ClientTranslationKeyValue: parameter_value,
      CountryId: countryStore.country,
      Culture: selectedCulture,
    };
    if (
      parameter_key &&
      parameter_key.trim().length > 0 &&
      parameter_value &&
      parameter_value.trim().length > 0
    ) {
      MobilePanelClientTranslationCommand.PutMobilePanelClientTranslation(params)
        .then((_res: any) => {
          Swal.fire(t("general.updated"), " ", "success");
          refresh();
          onClose();
        })
        .catch((error: any) => {
          console.log("Hata :>> ", error);
        })
        .finally(() => {});
    } else {
      Swal.fire(t("mobilePanel.noEmpty"), " ", "error");
    }
  };

  const CreateMobilClientTranslationHandler = async () => {
    let params = {
      CountryId: countryStore.country,
      Culture: selectedCulture,
      ClientTranslationKey: parameter_key,
      ClientTranslationKeyValue: parameter_value,
    };
    if (
      parameter_key &&
      parameter_key.trim().length > 0 &&
      parameter_value &&
      parameter_value.trim().length > 0
    ) {
      MobilePanelClientTranslationCommand.CreateMobilePanelClientTranslation(params)
        .then((_res: any) => {
          Swal.fire(t("general.added"), " ", "success");
          refresh();
          onClose();
        })
        .catch((error: any) => {
          console.log("Hata :>> ", error);
        })
        .finally(() => {});
    } else {
      Swal.fire(t("mobilePanel.noEmpty"), " ", "error");
    }
    //:Swal.fire(t('general.emptyFieldControlText'), " ", "error");
  };

  const submitHandler = (event: any) => {
    event.preventDefault();
    CreateMobilClientTranslationHandler();
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("mobilePanel.mobilePanelClientTranslation")}</DialogTitle>
      <form onSubmit={submitHandler}>
        <DialogContent>
          <TextField
            label="Key"
            margin="dense"
            id="parameter_key"
            fullWidth
            variant="standard"
            defaultValue={selectedRow?.parameter_key}
            onChange={handleChangeParameterKey}
          />
          <TextField
            label="Value"
            margin="dense"
            id="parameter_value"
            fullWidth
            variant="standard"
            defaultValue={selectedRow?.parameter_value}
            onChange={handleChangeParameterValue}
            multiline
            rows={4}
          />
        </DialogContent>
        <DialogActions>
          {selectedRow?.id ? (
            <Button onClick={UpdateMobileClientTranslation}>
              {t("general.update")}
            </Button>
          ) : (
            <Button type="submit">{t("general.save")} </Button>
          )}
          <Button onClick={onClose}>{t("general.cancel")} </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
